import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as styles from "./select.module.css";
import { Controller } from "react-hook-form";
import ReactSelect from "react-select";
import CreatableSelect from "react-select/creatable";
import clsx from "clsx";
import { ErrorMessage } from "../errorMessage/ErrorMessage";
const selectStyles = {
  menuPortal: base => ({
    ...base,
    zIndex: 100
  }),
  option: base => ({
    ...base,
    fontFamily: `var(--conduction-input-select-list-option-font-family, ${base.fontFamily})`,
    backgroundColor: `var(--conduction-input-select-list-option-background-color, ${base.backgroundColor}) `,
    "&:hover": {
      backgroundColor: `var(--conduction-input-select-list-option-hover-background-color, ${base.backgroundColor})`,
      color: `var(--conduction-input-select-list-option-hover-color, ${base.color})`,
      fontFamily: `var(--conduction-input-select-list-option-hover-font-family, var(--conduction-input-select-list-option-font-family, ${base.fontFamily}))`
    }
  }),
  placeholder: base => ({
    ...base,
    fontFamily: `var(--conduction-input-select-placeholder-font-family, var(--utrecht-form-input-placeholder-font-family, ${base.fontFamily}))`,
    color: `var(--conduction-input-select-placeholder-color, var(--utrecht-form-input-placeholder-color, ${base.color}) )`
  })
};
const selectMultiStyles = {
  menuPortal: base => ({
    ...base,
    zIndex: 100
  }),
  option: base => ({
    ...base,
    fontFamily: `var(--conduction-input-select-list-option-font-family, ${base.fontFamily})`,
    backgroundColor: `var(--conduction-input-select-list-option-background-color, ${base.backgroundColor}) `,
    "&:hover": {
      backgroundColor: `var(--conduction-input-select-list-option-hover-background-color, ${base.backgroundColor})`,
      color: `var(--conduction-input-select-list-option-hover-color, ${base.color})`,
      fontFamily: `var(--conduction-input-select-list-option-hover-font-family, var(--conduction-input-select-list-option-font-family, ${base.fontFamily}))`
    }
  }),
  placeholder: base => ({
    ...base,
    fontFamily: `var(--conduction-input-select-placeholder-font-family, var(--utrecht-form-input-placeholder-font-family, ${base.fontFamily}))`,
    color: `var(--conduction-input-select-placeholder-color, var(--utrecht-form-input-placeholder-color, ${base.color}) )`
  })
};
export const SelectMultiple = _ref => {
  let {
    id,
    name,
    options,
    errors,
    control,
    validation,
    defaultValue,
    disabled,
    hideErrorMessage,
    menuPlacement,
    placeholder
  } = _ref;
  return _jsx(Controller, {
    ...{
      control,
      name,
      defaultValue
    },
    rules: validation,
    render: _ref2 => {
      let {
        field: {
          onChange,
          value
        }
      } = _ref2;
      return _jsxs(_Fragment, {
        children: [_jsx(ReactSelect, {
          inputId: id,
          value: value ?? "",
          className: clsx(styles.select, errors[name] && styles.error),
          isMulti: true,
          isDisabled: disabled,
          ...{
            options,
            onChange,
            errors
          },
          menuPortalTarget: document.body,
          menuPlacement: menuPlacement,
          styles: selectStyles,
          placeholder: disabled ? "Disabled..." : placeholder ?? "Select one or more options..."
        }), errors[name] && !hideErrorMessage && _jsx(ErrorMessage, {
          message: errors[name].message
        })]
      });
    }
  });
};
export const SelectCreate = _ref3 => {
  let {
    id,
    name,
    options,
    errors,
    control,
    validation,
    defaultValue,
    disabled,
    hideErrorMessage,
    menuPlacement,
    placeholder
  } = _ref3;
  return _jsx(Controller, {
    ...{
      control,
      name,
      defaultValue
    },
    rules: validation,
    render: _ref4 => {
      let {
        field: {
          onChange,
          value
        }
      } = _ref4;
      return _jsxs(_Fragment, {
        children: [_jsx(CreatableSelect, {
          inputId: id,
          value: value ?? "",
          placeholder: disabled ? "Disabled..." : placeholder ?? "Select one or more options...",
          className: clsx(styles.select, errors[name] && styles.error),
          isMulti: true,
          isDisabled: disabled,
          ...{
            options,
            onChange,
            errors
          },
          menuPortalTarget: document.body,
          menuPlacement: menuPlacement,
          styles: selectStyles
        }), errors[name] && !hideErrorMessage && _jsx(ErrorMessage, {
          message: errors[name].message
        })]
      });
    }
  });
};
export const SelectSingle = _ref5 => {
  let {
    id,
    name,
    options,
    errors,
    control,
    validation,
    isClearable,
    defaultValue,
    disabled,
    hideErrorMessage,
    menuPlacement,
    placeholder
  } = _ref5;
  return _jsx(Controller, {
    ...{
      control,
      name,
      defaultValue
    },
    rules: validation,
    render: _ref6 => {
      let {
        field: {
          onChange,
          value
        }
      } = _ref6;
      return _jsxs(_Fragment, {
        children: [_jsx(ReactSelect, {
          inputId: id,
          value: value ?? "",
          className: clsx(styles.select, errors[name] && styles.error),
          isDisabled: disabled,
          ...{
            options,
            onChange,
            errors,
            isClearable
          },
          menuPortalTarget: document.body,
          menuPlacement: menuPlacement,
          styles: selectStyles,
          placeholder: disabled ? "Disabled..." : placeholder ?? "Select one or more options..."
        }), errors[name] && !hideErrorMessage && _jsx(ErrorMessage, {
          message: errors[name].message
        })]
      });
    }
  });
};